export const mainColor = "#80CBC4";
